import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import AntdMessage from '@src/components/antd/message';
import copy from '@src/components/copy';
class SuccessModalStore extends BaseModalStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable closeCallback = noop;

  //礼包码
  @observable cdk = '';

  @observable KvSectionStore;

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };

  download = () => {
    if (!this.KvSectionStore.downloadList[0].href) {
      AntdMessage.info('敬请期待~');
      return;
    }
    window.open(this.KvSectionStore.downloadList[0].href);
  };

  copy = () => {
    copy(this.cdk, { successPreText: '复制礼包码成功!' });
  };

  use() {
    super.use();
  }
}

export default SuccessModalStore;
